import React from 'react';
import { useRecipeContext } from '../../../contexts/recipes/recipe.tsx';

const RecipeHeader = () => {
  const { recipe } = useRecipeContext();
  return (
    <div>
      <h1>{recipe.name ?? "Create recipe"}</h1>
    </div>
  );
};

export default RecipeHeader;
